export function isInAppWebView(device) {
  if (!isMobile(device)) {
    return false;
  }
  const deviceUa = device.get("ua");
  const regexp = new RegExp("KAKAOTALK", "gi");
  const exec = regexp.exec(deviceUa);
  if (exec) {
    return true;
  }
  return false;
}

export function isMobile(device) {
  if (device.getIn(["device", "type"]) === "mobile") {
    return true;
  } else if (device.getIn(["device", "model"]) === "iPad") {
    return true;
  } else if (device.getIn(["device", "type"]) === "tablet") {
    return true;
  }
  return false;
}

export function getOSCode(device) {
  if (isIOS(device)) {
    return "iOS";
  }

  return device.getIn(["os", "name"]);
}

function isIOS(device) {
  const deviceOS = device.getIn(["os", "name"]);
  return deviceOS === "iOS" || (deviceOS === "Mac OS" && isMobile(device)); // ** ios >= 13부터 iPad의 ua는 os = Mac OS & type = mobile로 내려줌 (https://developer.apple.com/forums/thread/119186)
}

export function isKakaoTalkScrap(device) {
  const ua = device.get("ua");
  if (!!ua) {
    if (ua.indexOf("kakaotalk-scrap") >= 0) {
      return true;
    }
  }
  return false;
}

/**
 * version 명시 sample: 8.1.1
 */
export function isHigherKakaoTalkVersion(device, version) {
  const osName = device.getIn(["os", "name"]);
  const deviceUa = device.get("ua");
  const iosVersion = version;
  const aosVersion = version.replace(/\./g, "");

  let regexpPattern;
  const commonUserAgentRegex = "KAKAOTALK/(\\d|\\.){5,6}";
  if (osName === "iOS") {
    regexpPattern = `${commonUserAgentRegex}|KAKAOTALK (\\d|\\.){5,6}`;
  } else if (osName === "Android") {
    regexpPattern = `${commonUserAgentRegex}|(KAKAOTALK|KAKAOTALK_ONESTORE) \\d{7}`;
  } else {
    return false;
  }

  try {
    const regexp = new RegExp(regexpPattern, "gi");
    const exec = regexp.exec(deviceUa);
    if (exec) {
      const version = exec[0].slice(10);
      if (osName === "iOS" || version.includes(".")) {
        if (Number(version.replace(/\./g, "")) >= Number(iosVersion.replace(/\./g, ""))) {
          return true;
        }
      } else if (osName === "Android") {
        if (Number(version.slice(2, 6)) >= Number(aosVersion)) {
          return true;
        }
      }
    }
  } catch (e) {
    console.error("KAKAOTALK version check failed", e);
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/utils/deviceUtil.js